<template>
  <div class="ESGAdd-container">
    <v-header :title="isAdd?'ESG报告新建':'ESG报告编辑'"></v-header>
    <div class="goList">
      <el-button size="medium" @click="goList">返回列表页</el-button>
    </div>
    <div class="all-form">
      <el-form class="demo-ruleForm" :model="ruleForm" :rules="rules" ref="ruleForm">
        <el-form-item label="报告名称（25个字以内）" prop="ESGtitle" required>
          <br>
          <el-input v-model="ruleForm.ESGtitle" maxlength="25" clearable placeholder="请输入报告名称（25个字以内）"></el-input>
        </el-form-item>
        <el-form-item label="缩略图" prop="caroPic" ref="uploadElement" required>
          <br/>
          <input type="hidden" v-model="ruleForm.caroPic">
          <div class="uploadImg" v-if="!changeImgNews">
            <el-button size="medium">
              上传图片
              <input type="file" id="uploadtImgtx_news" accept="image/*" @change="change123_news($event)">
            </el-button>
          </div>
          <el-button @click="setChangeImgNews" v-if="changeImgNews" id="changeImgBtn" size="medium">更换图片</el-button>
          <div v-show="!redactImg_news">
            <div class="k_news" v-show="!cutImg_news"></div>
          </div>
          <div v-show="redactImg_news">
            <img class="redactImg_news" :src="imgUrl_news">
          </div>
          <div id="news_clipArea" v-show="cutImg_news"></div>
          <el-button size="medium" id="clipBtn_news" v-if="!changeImgNews">截取</el-button>
        </el-form-item>
        <el-form-item label="报告内容" prop="pageContent" required>
          <br>
          <u-editor :config='myConfig' :value='ruleForm.pageContent' @input="getContent"></u-editor>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="medium" @click="announce('ruleForm')">发布</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import api from '@/modules/api.js';
import url from '@/modules/url.js';
import Vue from 'vue'
import sessionstorage from '@/components/cache'
import getIP from '@/components/utils/getIP'
import UEditor from '@/layout/ueditor.vue'
import vHeader from '@/layout/Header1.vue'
import PhotoClip from 'photoclip_e_x'

// Vue.use(PhotoClip)
export default {
  components: {UEditor, vHeader},
  data() {
    let str = /^[a-zA-Z0-9_\u4e00-\u9fa5]+$/
    var ESGtitles = (rule, value, callback) => {
      // 调用设置验证正则表达式的方法
      let msg = this.test(value)
      if (!value) {
        callback(new Error('请输入报告名称'));
        return;
      } else if (!str.test(value)) {
        callback(new Error('报告名称只可输入数字字母汉字'));
        return;
      } else if (msg.hz * 2 + msg.fhz * 2 > 50) {
        callback(new Error('报告名称不可超过25个中文字符'));
        return;
      } else {
        callback();
      }
    }
    // 个险和公司的文章图片 不能超500
    const caroPicValid = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请上传图片'))
      } else {
        if (['FC', 'ALL'].indexOf(this.ruleForm.visiblePeople) >= 0 && this.fileLst_news.size > (500 * 1024)) {
          callback(new Error(`图片大小${(this.fileLst_news.size / 1024).toFixed(0)}kb超过500kb`))
        } else {
          callback() // 重点在这  如果在验证通过后不添加callback()函数在验证时是条件会为false
        }
      }
    }
    const pageContent = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入报告内容'))
      } else {
        callback()
      }
    }
    return {
      isAdd: '', // 当前是否是新增操作，这是一个boolean值，true或false
      id: '', // 报告主键，当编辑操作时，需要这个id，作为参数传入接口中
      ruleForm: {
        ESGtitle: '',
        caroPic: '',
        pageContent: ''
      },
      rules: {
        ESGtitle: [
          {validator: ESGtitles, trigger: ['change', 'blur']}
        ],
        caroPic: [
          {required: true, trigger: 'change', validator: caroPicValid}
        ],
        pageContent: [
          {required: true, trigger: 'blur', validator: pageContent}
        ]
      },
      fileLst_news: {},
      changeImgNews: false,
      redactImg_news: false,
      cutImg_news: true,
      imgUrl_news: '',
      uploadUrl: process.env.UPLOAD_ROOT + '/file/v1/hasl/fileAdmin/fileAdmin/upload',
      myConfig: {
        // 编辑器不自动被内容撑高
        autoHeightEnabled: false,
        // 初始容器高度
        initialFrameHeight: 300,
        // 初始容器宽度
        initialFrameWidth: '100%',
        // UEditor 资源文件的存放路径
        UEDITOR_HOME_URL: './static/Ueditor/', //测试
        // UEDITOR_HOME_URL: '/static/Ueditor/',//本地环境
        //自定义工具栏
        toolbars: [[
          'fullscreen', 'undo', 'redo', '|',
          'bold', 'italic', 'underline', 'fontborder', 'strikethrough', 'superscript', 'subscript', 'removeformat', 'formatmatch', 'pasteplain', '|', 'forecolor', 'backcolor', 'cleardoc', '|',
          'rowspacingtop', 'rowspacingbottom', 'lineheight', '|',
          'customstyle', 'paragraph', 'fontfamily', 'fontsize', '|',
          'indent',
          'justifyleft', 'justifycenter', 'justifyright', 'justifyjustify', '|', 'touppercase', 'tolowercase', '|',
          'link', 'unlink', 'anchor', '|', 'imagenone', 'imageleft', 'imageright', 'imagecenter', '|', 'simpleupload',
          'horizontal', 'date', 'time', 'spechars', '|',
          'inserttable', 'deletetable', 'insertparagraphbeforetable', 'insertrow', 'deleterow', 'insertcol', 'deletecol', 'mergecells', 'mergeright', 'mergedown', 'splittocells', 'splittorows', 'splittocols', 'charts', '|',
          'preview', 'searchreplace'
        ]],
        serverUrl: '',
        enableContextMenu: false, //关闭右键菜单
        enableAutoSave: false //关闭自动保存 ueditor.all.js内'contentchange': function添加if(!me.getOpt('enableAutoSave')) {return;}
      }
    }
  },
  activated() {
    // 调用页面初始化方法
    this.init()
  },
  methods: {
    /**
     * @Description: 页面初始化方法
     * @author:zhangqi
     * @Date:2021-10-26
     */
    init() {
      // 调用整个页面的加载遮罩的方法
      this.loading()
      // 清空重置变量，防止数据缓存
      this.isAdd = ''
      // 清空重置变量，防止数据缓存
      this.id = ''
      // this.getHeader()
      this.ruleForm = {
        ESGtitle: '',
        caroPic: '',
        pageContent: ''
      }
      var container = document.querySelector('#main_div')
      container.scrollTop = 0
      this.changeImgNews = false
      this.redactImg_news = false
      this.cutImg_news = true
      this.imgUrl_news = ''
      if (this.$refs['ruleForm']) {
        this.$refs['ruleForm'].resetFields()
      }
      // console.log('this.$route.query', this.$route.query)
      if (Object.keys(this.$route.query).length !== 0) {
        // 编辑操作，设置判断是否是新增操作的变量为false，表示当前不是新增操作
        this.isAdd = false
        this.ruleForm.ESGtitle = this.$route.query.list.title
        this.id = this.$route.query.list.id
        if (this.$route.query.list.thumbnail) {
          this.changeImgNews = true
          this.redactImg_news = true
          this.cutImg_news = false
          this.imgUrl_news = this.ruleForm.caroPic = this.$route.query.list.thumbnail
          this.ruleForm.pageContent = this.$route.query.list.content
        }
      } else {
        // 新增操作，设置判断是否是新增操作的变量为true，表示当前是新增操作
        this.isAdd = true
      }
      this.openNews()
    },

    /**
     * @Description: 整个页面的加载遮罩的方法
     * @author:zhangqi
     * @Date:2021-10-26
     */
    loading() {
      const loading = this.$loading({
        lock: true,
        text: '加载中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      setTimeout(() => {
        loading.close()
      }, 1000)
    },

    /**
     * @Description: 点击页面右上角‘返回列表页’按钮触发的方法
     * @author:zhangqi
     * @Date:2021-10-26
     */
    goList() {
      // console.log('返回列表页')
      this.$router.go(-1)
    },

    /**
     * @Description: 验证报告名称输入项时，设置验证正则表达式的方法
     * @params: str--报告名称字段的输入项内容
     * @author:zhangqi
     * @Date:2021-10-26
     */
    test(str) {
      var reg1 = /([\u4e00-\u9fa5]*)/g
      var reg2 = /([\dA-Za-z]*)/g
      return {
        'hz': str.match(reg1).join('').length,
        'fhz': str.match(reg2).join('').length
      }
    },
    /**
     * @Description: 获取富文本编辑器中输入的内容的方法
     * @params: obj--编辑器中输入的内容的数据对象
     * @author:zhangqi
     * @Date:2021-10-27
     */
    getContent(obj) {
      this.ruleForm.pageContent = obj.content
    },

    /**
     * @Description: 点击'发布'按钮执行的方法
     * @author:zhangqi
     * @Date:2021-10-27
     */
    announce(formName) {
      let params = {
        title: this.ruleForm.ESGtitle,
        teamCode: sessionStorage.getItem('teamCode'),
        thumbnail: this.imgUrl_news,
        content: this.ruleForm.pageContent
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // 判断当前如果是编辑操作的情况下，要在参数对象中添加一个id数据
          if (!this.isAdd) {
            params.id = this.id
          }
          api.post(url.editEsgReports, params, res => {
            if (res.result.isSuccess) {
              this.$message({
                type: 'success',
                message: `ESG报告${this.isAdd ? '新增' : '编辑'}成功`,
                onClose: () => {
                  // 提示语关闭后，返回上一个页面
                  this.goList()
                }
              });
            } else {
              this.$message({
                type: 'error',
                message: res.result.error
              });
            }
          })
        } else {
          console.log('error submit!!');
          return false
        }
      });

    },
    openNews() {
      let _this = this
      _this.pc_news = new PhotoClip('#news_clipArea', {
        size: [240, 155],
        outputSize: 340,
        file: '#uploadtImgtx_news',
        view: '.k_news',
        ok: '#clipBtn_news',
        loadStart: function () {
          console.log('开始读取照片')
        },
        loadComplete: function () {
          console.log('照片读取完成')
        },
        done: function (dataURL) {
          _this.redactImg_news = false
          if (!_this.cutImg_news) {
            _this.$message({
              message: '请勿重复截取',
              type: 'warning'
            })
          } else {
            _this.fileLst_news = _this.dataURLtoFile(dataURL, _this.filename_news)
            _this.uploadImg(_this.fileLst_news)
          }
        },
        fail: function (msg) {
          _this.$message.error(msg)
        }
      })
    },
    change123_news(val) {
      console.log(val)
      this.cutImg_news = true
      this.filename_news = val.currentTarget.files[0].name
      console.log(this.filename_news)
      this.redactImg_news = false
    },
    setChangeImgNews() {
      this.changeImgNews = false
      if (this.pc_news != null) {
        this.pc_news.destroy()
      }
      this.$nextTick(() => {
        this.openNews()
      })
      this.imgUrl_news = ''
      this.ruleForm.caroPic = ''
      this.cutImg_news = true
      this.redactImg_news = false
    },


    dataURLtoFile(dataurl, filename) { // 将base64转换为文件
      let arr = dataurl.split(',')
      let mime = arr[0].match(/:(.*?);/)[1]
      let bstr = atob(arr[1])
      let n = bstr.length
      let u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], filename, {type: mime})
    },
    uploadImg(fileList) { // 上传图片
      console.log(this.fileLst)
      let fd = new FormData()
      fd.append('domain', 'CONTENT')
      fd.append('buz', 'PICTURE')
      fd.append('expired', -1)
      fd.append('actions', '')
      fd.append('buzId', '6200155423')
      fd.append('file', fileList)
      fd.append('auth', 1)
      let _this = this
      let url = _this.uploadUrl
      axios({
        method: 'post',
        url,
        data: fd,
        // withCredentials: true,
        timeout: 30 * 1000, // 30秒超时
        headers: {
          'ComId': 'ebiz-agent',
          'Authorization': 'Basic ' + sessionstorage.session_get('token'),
          'Accept-Device': 'NULL',
          'Accept-DeviceOS': 'NULL',
          'Accept-Location': 'NULL',
          'Accept-ISP': 'NULL',
          'Accept-StartTime': 'NULL',
          'Accept-TimeZone': -(new Date().getTimezoneOffset() * 60000),
          'Accept-Attr1': getIP.getBrowserInfo(),
          'Accept-Attr2': 'PC',
          'Accept-Attr3': '',
          'Real-Ip': getIP.getBrowserInfo(),
          'Accept-Attr4': 'NULL',
          'Accept-Attr6': sessionstorage.session_get('username')
        }
      }).then(response => {
        if (response.data.result.isSuccess == true) {
          let data = response.data.data
          _this.imgUrl_news = _this.ruleForm.caroPic = _this.$linkUrl + data.fileId + '.' + data.ext
          _this.cutImg_news = false
        }
      }).catch(error => {
        if (error) {
          console.log(error)
          // reject(new Error('接口调用失败'))
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.ESGAdd-container {
  .goList {
    padding-top: 75px;
    width: 100%;
    display: flex;
    justify-content: flex-end;

    button {
      margin-right: 50px;
    }
  }

  .all-form {
    margin-left: 5%;
    padding-bottom: 5%;
  }

  .all-form::-webkit-scrollbar {
    width: 0px;
  }

  /deep/ .el-form-item__content {
    margin-left: 5%;

    .el-input {
      width: 80%;
    }
  }

  .redactImg_news {
    width: 400px;
    height: 250px;
    box-shadow: 0px 0px 10px #888888;
  }

  /deep/ .edui-editor {
    width: 80% !important;
  }

  /deep/ .edui-button-wrap {
    height: 20px !important;
    line-height: 20px !important;
  }

  /deep/ .edui-menubutton-body {
    height: 20px !important;
    line-height: 20px !important;
  }

  /deep/ .edui-combox-body {
    height: 20px !important;
    line-height: 20px !important;
  }

  /deep/ .edui-default .edui-editor-breadcrumb {
    display: none;
  }
}


.uploadImg {
  position: relative;
  overflow: hidden;
  display: inline-block;
  margin-right: 30px;
}

#uploadtImgtx_news {
  width: 11.5vw;
  height: 6vh;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
}

#changeImgBtn {
  margin-bottom: 20px;
}

#redactImg {
  padding-top: 20px;
}

#clipBtn {
  cursor: pointer;
}

.k_news {
  width: 25vw;
  height: 38.7vh;
}

#news_clipArea {
  height: 38.7vh;
  width: 25vw;
  margin-bottom: 10px;
}

.edui-default .edui-editor-breadcrumb {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/pages/performance/ESGAdd.vue